const url =
  "https://excalidraw-joey-backend.netlify.app/.netlify/functions/app";
const SECURE_KEY = import.meta.env.VITE_SECURE_KEY || "SECURE_KEY";

type SessionData = {
  sessionName: string;
  sessionId: string;
  content: string;
};

type SessionsResponse = Record<string, SessionData>;

export const createSession = async (partialData: object) => {
  const response = await fetch(`${url}/createSession`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-secure-key": SECURE_KEY,
    },
    body: JSON.stringify(partialData),
  });
  if (!response.ok) {
    throw new Error(
      `HTTP error! Status: ${
        response.status
      }, Message: ${await response.text()}`,
    );
  }
};

export const patchSession = async (partialData: object) => {
  const response = await fetch(`${url}/patchSession`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      "X-secure-key": SECURE_KEY,
    },
    body: JSON.stringify(partialData),
  });
  if (!response.ok) {
    throw new Error(
      `HTTP error! Status: ${
        response.status
      }, Message: ${await response.text()}`,
    );
  }
};

export const getAllExistingSessions = async (): Promise<SessionsResponse> => {
  const response = await fetch(`${url}/getAllExistingSessions`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-secure-key": SECURE_KEY,
    },
  });
  if (!response.ok) {
    throw new Error(
      `HTTP error! Status: ${
        response.status
      }, Message: ${await response.text()}`,
    );
  }
  return await response.json();
};

export const deleteSession = async (sessionName: string) => {
  const response = await fetch(
    `${url}/deleteSession/${encodeURIComponent(sessionName)}`,
    {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        "X-secure-key": SECURE_KEY,
      },
    },
  );
  if (!response.ok) {
    throw new Error(
      `HTTP error! Status: ${
        response.status
      }, Message: ${await response.text()}`,
    );
  }
};
